import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormService } from 'src/app/shared/services/form.service';


@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss']
})
export class UserFormComponent implements OnInit {
  userForm: FormGroup;
  minRetirementAge = 18;
  constructor(private formService: FormService, private formBuilder: FormBuilder) {
    this.userForm = this.formService.userObjectForm;
   }

  ngOnInit(): void {
  }

  adjRetirementAge(){
    if(this.userForm.value.currentAge){
      //reset min val to be current age
      /* this.userForm.controls['retirementAge'].clearValidators();
      this.userForm.controls['retirementAge'].setValidators([Validators.required, Validators.min(this.userForm.value.currentAge), Validators.max(110)]);
      this.userForm.controls['retirementAge'].updateValueAndValidity();
      
      this.minRetirementAge = this.userForm.value.currentAge; */

      this.formService.userObjectForm.controls['isCurrentAgeMedicareAge'].setValue((this.userForm.value.currentAge >= 65));
    }
  }

}
